module.exports = __webpack_public_path__ + "img/clipboard-check.c4b70528.svg";